import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBexq0He7wt1NHRTo_hn97w_dTiX5FRRn0",
  authDomain: "nagesha-clicks.firebaseapp.com",
  projectId: "nagesha-clicks",
  storageBucket: "nagesha-clicks.firebasestorage.app",
  appId: "1:118080894797:web:4af98e13b4639f42b82904",
  measurementId: "G-NQX1MTT17J",
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, firestore, storage, db, ref, uploadBytes };
